import AlphaPagination from "./AlphaPagination";

const { register } = require("@lpm/pug-components/dist/register");

register("AlphaPagination/AlphaPagination", AlphaPagination);